export const sizeBoxOptions = [
  {
    value: "17X11X11 - Small-1",
    label: "17X11X11 - Small-1",
    volumeM: 2.84,
    volumeA: 12.39,
  },
  {
    value: "12X12X16 - Small-2",
    label: "12X12X16 - Small-2",
    volumeM: 1.33,
    volumeA: 13.87,
  },
  {
    value: "21X15X16 - Medium-1",
    label: "21X15X15 - Medium-1",
    volumeM: 2.92,
    volumeA: 39.84,
  },
  {
    value: "18X18X16 - Medium-2",
    label: "18X18X16 - Medium-2",
    volumeM: 3,
    volumeA: 31.22,
  },
  {
    value: "27X15X16 - Large-1",
    label: "27X15X16 - Large-1",
    volumeM: 3.75,
    volumeA: 38.03,
  },
  {
    value: "18X18X24 - Large-2",
    label: "18X18X24 - Large-2",
    volumeM: 4.5,
    volumeA: 46.84,
  },
  {
    value: "24X20X21 - ExtraLarge-1",
    label: "24X20X21 - ExtraLarge-1",
    volumeM: 5.83,
    volumeA: 60.72,
  },
  {
    value: "22X22X21 - ExtraLarge-2",
    label: "22X22X21 - ExtraLarge-2",
    volumeM: 5.88,
    volumeA: 61.22,
  },
  { value: "personality", label: "Tamaño personalizado" },
];

export const statusOptions = [
  { label: "Recibido en almacen", value: "Recibido en almacen" },
  { label: "En Transito terrestre", value: "En Transito terrestre" },
  { label: "En transito Matirimo/Aereo", value: "En transito Matirimo/Aereo" },
  { label: "En Aduana", value: "En Aduana" },
  { label: "En transito a destino", value: "En transito a destino" },
  { label: "Entregado", value: "Entregado" },
];

export const paymentMethods = [
  { label: "Zelle", value: "Zelle" },
  { label: "Tarjeta de crédito/debito", value: "Tarjeta de crédito/debito" },
  { label: "PayPal", value: "PayPal" },
  { label: "Venmo", value: "Venmo" },
  { label: "Cash", value: "Cash" },
];

export const shipmentTypeOptions = [
  { label: "Marítimo", value: "Marítimo" },
  { label: "Aéreo", value: "Aéreo" },
  { label: "Terrestre", value: "Terrestre" },
];

export const countryOptions = [
  { label: "Argentina", value: "Argentina" },
  { label: "Bolivia", value: "Bolivia" },
  { label: "Brasil", value: "Brasil" },
  { label: "Chile", value: "Chile" },
  { label: "Colombia", value: "Colombia" },
  { label: "Ecuador", value: "Ecuador" },
  { label: "Guatemala", value: "Guatemala" },
  { label: "Honduras", value: "Honduras" },
  { label: "México", value: "México" },
  { label: "Panamá", value: "Panamá" },
  { label: "Paraguay", value: "Paraguay" },
  { label: "Perú", value: "Perú" },
  { label: "República Dominicana", value: "República Dominicana" },
  { label: "Uruguay", value: "Uruguay" },
  { label: "Venezuela", value: "Venezuela" },
];

export const companyOptions = [
  { label: "Global Cargo", value: "global-cargo" },
];
